import { render, staticRenderFns } from "./ModalConfigShopify.vue?vue&type=template&id=5d7b1a62&"
import script from "./ModalConfigShopify.vue?vue&type=script&lang=js&"
export * from "./ModalConfigShopify.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfigShopify.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports